export default "__VITE_ASSET__Cmcd34TN__"